import styled from 'styled-components';

export const LibraryEntryStyled = styled.li`
  background-color: ${props => props.selected ? '#b7e9f9' : 'none'};
`